<template>
  <div class="home-right">
    <title-one :title="`${ curAgency.name || '' }能源消耗状况`" />
    <div class="rank-one left">
      <title-two :title="'能耗统计'" />
      <div class="map-one">
        <wh-echarts :id="'rightOne'" :option="optionOne" />
      </div>
      <title-two class="m-top" :title="'能耗占比'" />
      <div class="map-two">
        <wh-echarts :id="'rightTwo'" :option="optionTwo" />
      </div>
      <title-two class="m-top" :title="'单位产值能耗'" />
      <div class="map-three">
        <wh-echarts :id="'rightThree'" :option="optionThree" />
      </div>
      <title-two class="m-top" :title="'单位产品能耗'" />
      <div class="map-four">
        <wh-echarts :id="'rightFour'" :option="optionFour" />
      </div>
    </div>
  </div>
</template>

<script>
import TitleOne from '@/components/TitleOne/TitleOne'
import TitleTwo from '@/components/TitleTwo/TitleTwo'
import WhEcharts from '@/components/WhEcharts/WhEcharts'
import echarts from 'echarts'
import { mapState } from 'vuex'
export default {
  name: 'HomeRight',
  components: { WhEcharts, TitleTwo, TitleOne },
  data() {
    const linearGradientFn = (color1, color2) => {
      return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: color1 },
        { offset: 1, color: color2 }
      ])
    }
    return {
      optionOne: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['总能耗', '电力', '天然气', '煤炭', '其他'],
            nameTextStyle: {
              fontSize: 40
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            }
          }
        ],
        yAxis: {
          show: true,
          name: 'tce',
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.1)'
            }
          }
        },
        series: {
          name: '能耗统计',
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            fontSize: 16,
            color: '#35e8ce',
            formatter: '{c}'
          },
          itemStyle: {
            normal: {
              color: (params) => {
                // const colorList = ['#4d29b4', '#ca5252', '#0abec0', '#ffcb3a', '#1a6cb9']
                const colorList = [
                  linearGradientFn('#6334e5', '#341c79'),
                  linearGradientFn('#e45d5d', '#7c3232'),
                  linearGradientFn('#0df6f9', '#07898b'),
                  linearGradientFn('#efbf39', '#866b1e'),
                  linearGradientFn('#1e7ed9', '#104577')
                ]
                return colorList[params.dataIndex]
              }
            }
          },
          barWidth: '20%',
          data: []
        }
      },
      optionTwo: {
        color: ['#eb6060', '#35e8ce', '#ffcb3a', '#2085e4'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {d}%'
        },
        legend: {
          show: false
        },
        series: {
          name: '能耗占比',
          type: 'pie',
          radius: ['5%', '65%'],
          label: {
            formatter: '{b}: {d}%'
          },
          data: []
        }
      },
      optionThree: {
        tooltip: {
          show: false,
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: [
          {
            type: 'category',
            data: [2018, 2019, 2020],
            nameTextStyle: {
              fontSize: 40
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            }
          }
        ],
        yAxis: {
          show: true,
          name: 'tce/万元',
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.1)'
            }
          }
        },
        series: [
          {
            name: '产值能耗',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              fontSize: 16,
              color: '#35e8ce',
              formatter: '{c}'
            },
            itemStyle: {
              normal: {
                color: (params) => {
                  return linearGradientFn('rgba(32,133,228,0.2)', 'rgba(53,232,206,0.2)')
                }
              }
            },
            barWidth: '20%',
            data: []
          },
          {
            type: 'line',
            lineStyle: {
              color: '#35e8ce',
              width: 2
            },
            data: []
          }
        ]
      },
      optionFour: {
        tooltip: {
          show: false,
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            nameTextStyle: {
              fontSize: 40
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            axisTick: {
              show: false,
              alignWithLabel: true
            }
          }
        ],
        yAxis: {
          show: true,
          name: 'tce/t',
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.1)'
            }
          },
          max: 80
        },
        series: [
          {
            name: '产值能耗',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              fontSize: 16,
              color: '#35e8ce',
              formatter: '{c}'
            },
            itemStyle: {
              normal: {
                color: (params) => {
                  return linearGradientFn('rgba(32,133,228,0.8)', 'rgba(53,232,206,0.8)')
                }
              }
            },
            barWidth: '20%',
            data: [],
            markLine: {
              symbol: 'none',
              data: [
                {
                  name: '123',
                  yAxis: 40,
                  label: {
                    formatter: '先进值',
                    position: 'right'
                  },
                  lineStyle: {
                    color: '#ffcb3a'
                  }
                },
                {
                  name: '123',
                  yAxis: 40,
                  label: {
                    formatter: '标准值',
                    position: 'right'
                  },
                  lineStyle: {
                    color: '#f00'
                  }
                }
              ]
            }
          },
          {
            type: 'line',
            lineStyle: {
              color: '#35e8ce',
              width: 2
            },
            data: []
          }
        ]
      }
    }
  },
  computed: {
    ...mapState([
      'curAgency'
    ])
  },
  watch: {
    curAgency: {
      handler(newV, oldV) {
        this.optionOne.series.data = newV.energyUseStatistics || []
        this.optionTwo.series.data = (newV.energyProportionLegend || []).map((item, index) => {
          return {
            value: newV.energyProportion[index] || 0,
            name: item
          }
        })
        this.optionThree.xAxis[0].data = newV.unitOutputDate || []
        this.optionThree.series[0].data = this.optionThree.series[1].data = newV.unitOutputNum || []
        // 产值能耗单位
        this.optionFour.yAxis.name = newV.useUnit ? newV.useUnit : 'tec/t'
        // 先进值+标准值
        this.optionFour.series[0].markLine.data[0].yAxis = this.isValid(newV.advanced)
        this.optionFour.series[0].markLine.data[0].label.show = this.isValid(newV.advanced) !== 0
        this.optionFour.series[0].markLine.data[0].lineStyle.color = this.isValid(newV.advanced) !== 0 ? '#ffcb3a' : 'rgba(0, 0, 0, 0)'
        this.optionFour.series[0].markLine.data[1].yAxis = this.isValid(newV.standard)
        this.optionFour.series[0].markLine.data[1].label.show = this.isValid(newV.standard) !== 0
        this.optionFour.series[0].markLine.data[1].lineStyle.color = this.isValid(newV.advanced) !== 0 ? '#f00' : 'rgba(0, 0, 0, 0)'
        this.optionFour.xAxis[0].data = newV.unitProductDate || []
        this.optionFour.series[0].data = this.optionFour.series[1].data = newV.unitProductNum || []
        this.optionFour.yAxis.max = Math.max(...this.optionFour.series[0].data, newV.advanced || 0, newV.standard || 0)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    isValid(str) {
      if (!str) return 0
      if (str === '0') return 0
      return str
    }
  }
}
</script>

<style lang="less" scoped>
  .rank-one{
    width: 100%;
    height: 1213px;
    padding: 40px 40px 0;
    background: url("../images/right-1.png") top left no-repeat;
    background-size: 100% 100%;
    .map-one, .map-two, .map-three, .map-four{
      height: 258px;
    }
  }
  .m-top{
    margin-top: 16px;
  }
  .left{
    position: relative;
    top: -6px;
  }
</style>
